var _mask, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _path20, _path21, _path22, _path23, _g5, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g6, _path32, _path33, _path34, _path35, _g7, _path36, _path37, _path38, _path39, _g8, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g9, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g0, _path55, _path56, _path57, _g1, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 700,
    viewBox: "0 0 620 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_15956)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_272_15956",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00002C0 3.58174 3.58172 0 8 0H620V700H7.99999C3.58171 700 0 696.418 0 692V8.00002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00002C0 3.58174 3.58172 0 8 0H620V700H7.99999C3.58171 700 0 696.418 0 692V8.00002Z",
    fill: "url(#paint0_linear_272_15956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.443 234H166.556L133 -16H469L435.443 234Z",
    fill: "#003076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.409 -7L108.887 399.232H493.528L444.006 -7",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: -7,
    width: 386,
    height: 407
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.411 -7L108.889 399.232H493.53L444.008 -7",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M493.532 399.224H108.881L129.59 229.348H472.823L493.532 399.224Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.409 -7L108.887 399.232H493.528L444.006 -7",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M433.54 -7H168.873L122.98 399.232H479.433L433.54 -7Z",
    fill: "#003076"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.541 -1.33313L261.829 -4.83254C260.878 -6.77499 258.868 -7.94978 256.703 -7.8263L225.073 -6.04072C223.314 -5.94227 221.941 -4.42702 222.008 -2.65646L222.145 1.00317L196.937 2.42662C195.002 2.53509 193.617 4.39911 194.071 6.28649L218.492 108.058L389.227 98.4226L405.945 -5.67026C406.254 -7.60102 404.737 -9.29983 402.802 -9.19136L263.541 -1.33313Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M408.433 0.811445L406.504 12.7932L392.141 102.289C391.679 105.143 389.301 107.296 386.447 107.463L221.931 116.741C219.077 116.908 216.536 115.022 215.87 112.235L193.164 17.616L192.063 13.0269C191.615 11.1411 193.001 9.2721 194.93 9.17197L405.294 -2.70966C407.238 -2.80979 408.746 -1.10764 408.433 0.811445Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: -3,
    width: 218,
    height: 120
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.429 0.810468L406.5 12.7922L392.137 102.288C391.675 105.142 389.297 107.295 386.443 107.462L221.927 116.74C219.073 116.907 216.532 115.021 215.866 112.234L193.16 17.615L192.059 13.0259C191.611 11.1402 192.997 9.27112 194.927 9.171L405.29 -2.71064C407.234 -2.81076 408.742 -1.10862 408.429 0.810468Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M406.502 12.793L392.139 102.289C391.677 105.143 389.299 107.295 386.445 107.462L221.929 116.741C219.075 116.908 216.534 115.022 215.869 112.235L193.162 17.6157L406.502 12.793Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M408.433 0.811445L406.504 12.7932L392.141 102.289C391.679 105.143 389.301 107.296 386.447 107.463L221.931 116.741C219.077 116.908 216.536 115.022 215.87 112.235L193.164 17.616L192.063 13.0269C191.615 11.1411 193.001 9.2721 194.93 9.17197L405.294 -2.70966C407.238 -2.80979 408.746 -1.10764 408.433 0.811445Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M267.163 21.905L265.707 18.2254C264.898 16.1828 262.952 14.7744 260.744 14.6325L228.488 12.5616C226.694 12.4465 225.179 13.7831 225.103 15.547L224.948 19.1949L199.24 17.5445C197.267 17.4177 195.712 19.0982 196.019 21.0256L212.629 124.96L386.742 136.139L412.086 34.8981C412.556 33.0207 411.153 31.15 409.18 31.0232L267.163 21.905Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M414.085 41.951L409.954 58.4385L389.381 140.642C388.688 143.412 386.093 145.281 383.185 145.081L215.407 134.317C212.499 134.134 210.08 131.948 209.618 129.111L195.418 40.2155L193.434 27.7832C193.122 25.8641 194.685 24.1786 196.655 24.3121L411.177 38.0795C413.147 38.213 414.561 40.082 414.085 41.951Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 24,
    width: 222,
    height: 122
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.087 41.953L409.956 58.4404L389.383 140.644C388.69 143.414 386.095 145.283 383.187 145.083L215.409 134.319C212.501 134.136 210.082 131.95 209.62 129.113L195.42 40.2174L193.436 27.7851C193.124 25.866 194.687 24.1806 196.657 24.3141L411.179 38.0814C413.149 38.2149 414.562 40.084 414.087 41.953Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M409.957 58.4407L389.384 140.644C388.691 143.414 386.096 145.284 383.188 145.083L215.411 134.32C212.503 134.136 210.084 131.95 209.622 129.113L195.422 40.2178L409.957 58.4407Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M414.085 41.951L409.954 58.4385L389.381 140.642C388.688 143.412 386.093 145.281 383.185 145.081L215.407 134.317C212.499 134.134 210.08 131.948 209.618 129.111L195.418 40.2155L193.434 27.7832C193.122 25.8641 194.685 24.1786 196.655 24.3121L411.177 38.0795C413.147 38.213 414.561 40.082 414.085 41.951Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264.069 48.5246L262.426 44.9551C261.514 42.9726 259.47 41.6943 257.216 41.6943H224.279C222.447 41.6943 220.962 43.1211 220.962 44.8833V48.5246H194.712C192.696 48.5246 191.185 50.2985 191.583 52.1976L213.003 154.612H390.791L412.211 52.1976C412.608 50.2985 411.098 48.5246 409.083 48.5246H264.069Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.554 164.051H216.238C213.266 164.051 210.707 162.037 210.121 159.236L189.241 59.4005C188.845 57.5014 190.354 55.7275 192.369 55.7275H411.422C413.437 55.7275 414.947 57.5014 414.55 59.4005L393.67 159.236C393.084 162.037 390.525 164.051 387.554 164.051Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.339 72.8398L261.664 69.282C260.734 67.3062 258.651 66.0312 256.353 66.0312H222.779C220.912 66.0312 219.398 67.4547 219.398 69.2103V72.8398H192.641C190.586 72.8398 189.047 74.6071 189.452 76.5011L211.284 178.603H392.509L414.343 76.5011C414.748 74.6087 413.208 72.8398 411.154 72.8398H263.339Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M389.212 188.327H214.583C211.554 188.327 208.945 186.318 208.349 183.526L187.065 83.9953C186.66 82.1029 188.2 80.334 190.254 80.334H413.541C415.595 80.334 417.135 82.1012 416.73 83.9953L395.446 183.526C394.85 186.318 392.241 188.327 389.212 188.327Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M407.388 98.0916H263.727L262.098 94.412C261.194 92.3694 259.171 91.0527 256.937 91.0527H224.306C222.49 91.0527 221.02 92.5246 221.02 94.3385V98.0916H195.014C193.018 98.0916 191.521 99.9189 191.915 101.876L213.135 207.423H389.267L410.487 101.876C410.881 99.9189 409.384 98.0916 407.388 98.0916Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M412.812 106.179L410.977 115.29L392.12 209.058C391.552 211.945 389.016 214.031 386.062 214.031H216.348C213.394 214.031 210.858 211.945 210.291 209.058L190.983 113.071L189.598 106.179C189.214 104.226 190.699 102.391 192.702 102.391H409.708C411.711 102.391 413.196 104.226 412.812 106.179Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 102,
    width: 224,
    height: 113
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M412.816 106.177L410.981 115.288L392.124 209.056C391.556 211.943 389.02 214.029 386.066 214.029H216.352C213.398 214.029 210.862 211.943 210.294 209.056L190.987 113.069L189.602 106.177C189.218 104.224 190.703 102.389 192.706 102.389H409.712C411.715 102.389 413.2 104.224 412.816 106.177Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M410.982 115.289L392.125 209.057C391.558 211.944 389.021 214.03 386.067 214.03H216.354C213.4 214.03 210.863 211.944 210.296 209.057L190.988 113.07L410.982 115.289Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.812 106.179L410.977 115.29L392.12 209.058C391.552 211.945 389.016 214.031 386.062 214.031H216.348C213.394 214.031 210.858 211.945 210.291 209.058L190.983 113.071L189.598 106.179C189.214 104.226 190.699 102.391 192.702 102.391H409.708C411.711 102.391 413.196 104.226 412.812 106.179Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M409.934 122.403H262.83L261.163 118.735C260.237 116.699 258.166 115.386 255.878 115.386H222.466C220.607 115.386 219.101 116.853 219.101 118.662V122.403H192.473C190.429 122.403 188.897 124.225 189.299 126.176L211.028 231.409H391.38L413.109 126.176C413.511 124.225 411.978 122.403 409.934 122.403Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M415.482 130.774L413.646 139.686L394.305 233.354C393.704 236.224 391.118 238.293 388.097 238.293H214.312C211.291 238.293 208.705 236.224 208.104 233.354L188.696 139.369L186.927 130.774C186.527 128.822 188.062 126.986 190.098 126.986H412.311C414.347 126.986 415.882 128.822 415.482 130.774Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 126,
    width: 230,
    height: 113
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M415.48 130.774L413.644 139.686L394.303 233.354C393.702 236.224 391.116 238.293 388.095 238.293H214.31C211.289 238.293 208.703 236.224 208.102 233.354L188.694 139.369L186.925 130.774C186.525 128.822 188.06 126.986 190.096 126.986H412.309C414.345 126.986 415.88 128.822 415.48 130.774Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M413.644 139.686L394.303 233.354C393.702 236.225 391.115 238.294 388.095 238.294H214.309C211.288 238.294 208.702 236.225 208.101 233.354L188.693 139.369L413.644 139.686Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M415.482 130.774L413.646 139.686L394.305 233.354C393.704 236.224 391.118 238.293 388.097 238.293H214.312C211.291 238.293 208.705 236.224 208.104 233.354L188.696 139.369L186.927 130.774C186.527 128.822 188.062 126.986 190.098 126.986H412.311C414.347 126.986 415.882 128.822 415.482 130.774Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M412.479 146.718H261.933L260.227 143.06C259.28 141.03 257.16 139.721 254.819 139.721H220.624C218.722 139.721 217.18 141.183 217.18 142.987V146.718H189.929C187.836 146.718 186.269 148.534 186.681 150.48L208.918 255.4H393.49L415.727 150.48C416.139 148.534 414.572 146.718 412.479 146.718Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M414.908 151.599H187.495C185.403 151.599 183.836 153.416 184.248 155.36L205.925 257.637C206.533 260.506 209.189 262.57 212.275 262.57H390.129C393.214 262.57 395.871 260.506 396.479 257.637L418.156 155.36C418.568 153.416 416.999 151.599 414.908 151.599Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M415.024 166.027H261.035L259.29 162.38C258.32 160.356 256.152 159.051 253.758 159.051H218.782C216.836 159.051 215.259 160.51 215.259 162.309V166.028H187.384C185.245 166.028 183.641 167.839 184.061 169.78L206.807 274.387H395.6L418.345 169.78C418.767 167.837 417.164 166.027 415.024 166.027Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M417.511 171.197H184.898C182.758 171.197 181.155 173.007 181.575 174.947L203.748 276.918C204.371 279.779 207.087 281.836 210.243 281.836H392.166C395.321 281.836 398.038 279.779 398.66 276.918L420.833 174.947C421.254 173.007 419.65 171.197 417.511 171.197Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M417.567 185.333H260.135L258.351 181.698C257.36 179.681 255.144 178.379 252.696 178.379H216.937C214.948 178.379 213.336 179.832 213.336 181.626V185.334H184.838C182.651 185.334 181.01 187.14 181.442 189.074L204.697 293.367H397.71L420.964 189.074C421.393 187.138 419.755 185.333 417.567 185.333Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M420.104 190.801H182.304C180.118 190.801 178.466 192.603 178.9 194.539L184.473 219.554L201.561 296.2C202.212 299.054 204.982 301.106 208.203 301.106H394.204C397.425 301.106 400.195 299.054 400.846 296.2L409.223 258.603L423.508 194.539C423.942 192.603 422.29 190.801 420.104 190.801Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 190,
    width: 246,
    height: 112
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M420.108 190.799H182.308C180.122 190.799 178.47 192.601 178.904 194.537L184.477 219.552L201.565 296.198C202.216 299.052 204.986 301.105 208.207 301.105H394.208C397.429 301.105 400.199 299.052 400.85 296.198L409.227 258.601L423.512 194.537C423.946 192.601 422.294 190.799 420.108 190.799Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.475 219.553L201.563 296.2C202.214 299.053 204.984 301.106 208.205 301.106H394.206C397.426 301.106 400.196 299.053 400.847 296.2L409.225 258.602L184.475 219.553Z",
    fill: "white"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M420.104 190.801H182.304C180.118 190.801 178.466 192.603 178.9 194.539L184.473 219.554L201.561 296.2C202.212 299.054 204.982 301.106 208.203 301.106H394.204C397.425 301.106 400.195 299.054 400.846 296.2L409.223 258.603L423.508 194.539C423.942 192.603 422.29 190.801 420.104 190.801Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M254.096 304.72L251.994 301.22C250.826 299.278 248.357 298.103 245.699 298.226L206.855 300.012C204.694 300.11 203.009 301.626 203.09 303.396L203.259 307.056L172.302 308.479C169.925 308.588 168.225 310.452 168.782 312.339L198.773 414.111L408.448 404.475L428.978 300.382C429.359 298.452 427.495 296.753 425.119 296.861L254.096 304.72Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M432.035 306.865L429.666 318.846L412.027 408.343C411.459 411.196 408.539 413.349 405.034 413.516L202.997 422.794C199.492 422.961 196.372 421.075 195.554 418.288L167.669 323.669L166.317 319.08C165.766 317.194 167.468 315.325 169.838 315.225L428.18 303.344C430.567 303.243 432.419 304.946 432.035 306.865Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 303,
    width: 267,
    height: 120
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M432.031 306.864L429.662 318.845L412.023 408.342C411.455 411.195 408.535 413.348 405.031 413.515L202.993 422.793C199.488 422.96 196.368 421.074 195.55 418.287L167.665 323.668L166.313 319.079C165.762 317.193 167.464 315.324 169.834 315.224L428.176 303.343C430.563 303.242 432.415 304.945 432.031 306.864Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.665 318.846L412.026 408.342C411.459 411.196 408.538 413.349 405.034 413.515L202.996 422.794C199.491 422.961 196.371 421.075 195.553 418.288L167.668 323.669L429.665 318.846Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M432.035 306.865L429.666 318.846L412.027 408.343C411.459 411.196 408.539 413.349 405.034 413.516L202.997 422.794C199.492 422.961 196.372 421.075 195.554 418.288L167.669 323.669L166.317 319.08C165.766 317.194 167.468 315.325 169.838 315.225L428.18 303.344C430.567 303.243 432.419 304.946 432.035 306.865Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M258.545 327.958L256.756 324.278C255.763 322.236 253.373 320.827 250.662 320.685L211.048 318.614C208.845 318.499 206.985 319.836 206.891 321.6L206.701 325.248L175.13 323.597C172.707 323.47 170.798 325.151 171.175 327.078L191.572 431.013L405.397 442.192L436.521 340.951C437.098 339.073 435.374 337.203 432.951 337.076L258.545 327.958Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M438.975 348.003L433.902 364.491L408.637 446.694C407.786 449.464 404.598 451.333 401.027 451.133L194.984 440.37C191.413 440.186 188.443 438 187.875 435.163L170.437 346.268L168 333.835C167.616 331.916 169.536 330.231 171.955 330.364L435.404 344.132C437.824 344.265 439.559 346.134 438.975 348.003Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 330,
    width: 273,
    height: 122
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M438.975 348.005L433.902 364.493L408.637 446.696C407.786 449.466 404.598 451.335 401.027 451.135L194.984 440.372C191.413 440.188 188.443 438.002 187.875 435.165L170.437 346.27L168 333.837C167.616 331.918 169.536 330.233 171.955 330.366L435.404 344.134C437.824 344.267 439.559 346.136 438.975 348.005Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M433.905 364.492L408.64 446.696C407.789 449.466 404.601 451.335 401.03 451.135L194.987 440.371C191.416 440.188 188.445 438.002 187.878 435.165L170.439 346.27L433.905 364.492Z",
    fill: "white"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M438.975 348.003L433.902 364.491L408.637 446.694C407.786 449.464 404.598 451.333 401.027 451.133L194.984 440.37C191.413 440.186 188.443 438 187.875 435.163L170.437 346.268L168 333.835C167.616 331.916 169.536 330.231 171.955 330.364L435.404 344.132C437.824 344.265 439.559 346.134 438.975 348.003Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.746 354.577L252.729 351.008C251.609 349.025 249.099 347.747 246.331 347.747H205.881C203.632 347.747 201.808 349.174 201.808 350.936V354.577H169.57C167.096 354.577 165.24 356.351 165.729 358.25L192.034 460.664H410.371L436.675 358.25C437.163 356.351 435.309 354.577 432.834 354.577H254.746Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M406.395 470.103H196.007C192.357 470.103 189.215 468.089 188.496 465.289L162.854 365.453C162.366 363.554 164.22 361.78 166.695 361.78H435.707C438.182 361.78 440.036 363.554 439.549 365.453L413.907 465.289C413.187 468.089 410.045 470.103 406.395 470.103Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M253.85 378.893L251.793 375.335C250.651 373.359 248.093 372.084 245.271 372.084H204.039C201.746 372.084 199.887 373.507 199.887 375.263V378.893H167.028C164.504 378.893 162.614 380.66 163.111 382.554L189.923 484.656H412.48L439.294 382.554C439.791 380.661 437.901 378.893 435.378 378.893H253.85Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M408.431 494.379H193.974C190.254 494.379 187.05 492.37 186.317 489.578L160.179 390.048C159.682 388.155 161.573 386.386 164.096 386.386H438.308C440.831 386.386 442.722 388.153 442.225 390.048L416.087 489.578C415.354 492.37 412.15 494.379 408.431 494.379Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M452.009 609.403H150.395L84.3789 422.182H518.025L452.009 609.403Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 422,
    width: 435,
    height: 188
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M452.011 609.404H150.397L84.3809 422.183H518.027L452.011 609.404Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M452.011 609.404H150.397L84.3809 422.183H518.027L452.011 609.404Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M452.009 609.403H150.395L84.3789 422.182H518.025L452.009 609.403Z",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M512.287 397.548H90.1178L84.3789 422.182H518.025L512.287 397.548Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M196.522 507.96L192.293 547.927H410.114L405.886 507.96H396.273L399.015 536.493H203.392L206.134 507.96H196.522Z",
    fill: "#BFBFBF",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M408.474 557.11H193.933L192.293 547.925H410.114L408.474 557.11Z",
    fill: "#757575",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M396.275 507.96L394.932 518.555L396.275 536.493H399.017L396.275 507.96Z",
    fill: "#757575",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.132 507.96L207.476 518.555L206.132 536.493H203.391L206.132 507.96Z",
    fill: "#757575",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M302.553 150.953L301.176 147.033C300.412 144.857 298.281 143.243 295.739 142.916L258.632 138.134C256.568 137.868 254.706 139.123 254.472 140.939L253.988 144.693L224.416 140.882C222.146 140.59 220.209 142.199 220.404 144.213L230.926 252.913L431.215 278.727L468.954 176.247C469.653 174.346 468.188 172.298 465.919 172.006L302.553 150.953Z",
    fill: "#EDB560"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 138,
    width: 250,
    height: 141
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M302.553 150.954L301.176 147.034C300.412 144.858 298.281 143.244 295.739 142.917L258.632 138.134C256.568 137.869 254.706 139.124 254.472 140.939L253.988 144.694L224.416 140.882C222.146 140.59 220.209 142.199 220.404 144.213L230.926 252.914L431.215 278.728L468.954 176.247C469.653 174.346 468.188 172.299 465.919 172.007L302.553 150.954Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M302.553 150.954L301.176 147.034C300.412 144.858 298.281 143.244 295.739 142.917L258.632 138.134C256.568 137.869 254.706 139.124 254.472 140.939L253.988 144.694L224.416 140.882C222.146 140.59 220.209 142.199 220.404 144.213L230.926 252.914L431.215 278.728L468.954 176.247C469.653 174.346 468.188 172.299 465.919 172.007L302.553 150.954Z",
    fill: "#EDB560"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M302.553 150.953L301.176 147.033C300.412 144.857 298.281 143.243 295.739 142.916L258.632 138.134C256.568 137.868 254.706 139.123 254.472 140.939L253.988 144.693L224.416 140.882C222.146 140.59 220.209 142.199 220.404 144.213L230.926 252.913L431.215 278.727L468.954 176.247C469.653 174.346 468.188 172.298 465.919 172.006L302.553 150.953Z",
    fill: "#EDB560",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M470.849 182.423L436.689 275.19L434.052 282.332C433.018 285.136 429.864 286.838 426.526 286.404L233.516 261.539C230.179 261.105 227.559 258.652 227.275 255.682L217.012 149.715C216.829 147.696 218.764 146.094 221.034 146.377L385.274 167.554L467.812 178.184C470.081 178.485 471.55 180.537 470.849 182.423Z",
    fill: "url(#paint1_linear_272_15956)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_272_15956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 146,
    width: 255,
    height: 141
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M470.853 182.423L436.693 275.19L434.056 282.333C433.022 285.136 429.868 286.838 426.53 286.404L233.52 261.54C230.183 261.106 227.563 258.653 227.279 255.682L217.016 149.715C216.832 147.696 218.768 146.094 221.038 146.378L385.278 167.555L467.815 178.185C470.085 178.485 471.553 180.538 470.853 182.423Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_272_15956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M470.852 182.421L436.693 275.188C412.479 269.464 411.561 254.378 407.506 246.569C403.033 237.958 374.681 233.385 366.754 232C358.828 230.598 354.005 222.588 354.005 222.588C346.863 202.53 384.143 185.041 384.143 185.041C383.409 182.288 384.493 173.259 385.278 167.552L467.815 178.182C470.085 178.483 471.553 180.535 470.852 182.421Z",
    fill: "url(#paint2_linear_272_15956)"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M470.849 182.423L436.689 275.19L434.052 282.332C433.018 285.136 429.864 286.838 426.526 286.404L233.516 261.539C230.179 261.105 227.559 258.652 227.275 255.682L217.012 149.715C216.829 147.696 218.764 146.094 221.034 146.377L385.274 167.554L467.812 178.184C470.081 178.485 471.55 180.537 470.849 182.423Z",
    fill: "url(#paint3_linear_272_15956)",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M253.307 178.265L255.947 243.843L279.713 246.923L282.502 181.566L253.307 178.265Z",
    fill: "white",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M267.805 239.031C268.538 236.752 267.897 234.209 266.649 232.166C265.401 230.124 263.602 228.485 261.826 226.878C264.576 228.456 267.65 229.469 270.799 229.84C270.766 226.424 267.51 224.051 264.601 222.259C265.9 221.745 267.432 221.86 268.638 222.562C268.747 221.503 268.284 220.403 267.455 219.737C267.817 220.049 268.394 219.559 268.376 219.08C268.358 218.602 268.019 218.209 267.785 217.791C267.25 216.832 267.251 215.675 267.268 214.577C267.326 210.652 267.383 206.727 267.442 202.802C267.543 203.518 268.112 204.144 268.815 204.313C268.77 202.757 268.623 201.209 268.476 199.66C268.104 195.732 267.734 191.805 267.361 187.877",
    fill: "#EDB560"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M267.805 239.031C268.538 236.752 267.897 234.209 266.649 232.166C265.401 230.124 263.602 228.485 261.826 226.878C264.576 228.456 267.65 229.469 270.799 229.84C270.766 226.424 267.51 224.051 264.601 222.259C265.9 221.745 267.432 221.86 268.638 222.562C268.747 221.503 268.284 220.403 267.455 219.737C267.817 220.049 268.394 219.559 268.376 219.08C268.358 218.602 268.019 218.209 267.785 217.791C267.25 216.832 267.251 215.675 267.268 214.577C267.326 210.652 267.383 206.727 267.442 202.802C267.543 203.518 268.112 204.144 268.815 204.313C268.77 202.757 268.623 201.209 268.476 199.66C268.104 195.732 267.734 191.805 267.361 187.877",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M645.342 391.504C645.342 391.504 510.667 271.022 502.085 263.43C493.502 255.839 487.231 256.168 482.61 251.547C477.989 246.926 475.678 243.626 456.863 243.956C438.047 244.286 412.961 234.053 407.35 230.422C401.738 226.791 393.816 229.433 388.535 227.377C383.253 225.321 369.719 227.121 361.467 227.377C353.215 227.632 352.555 219.2 355.855 209.626C359.156 200.054 384.243 194.111 387.544 196.092C390.844 198.073 404.048 192.461 404.048 192.461C402.067 185.529 402.728 168.694 402.728 168.694C402.728 168.694 388.864 162.754 383.582 160.773C378.3 158.792 371.038 159.453 371.038 159.453C371.038 159.453 372.688 151.883 375.33 149.066C377.97 146.249 390.514 143.609 402.728 135.027C414.941 126.444 422.533 124.464 424.513 125.124C426.494 125.785 440.028 129.745 443.659 129.745C447.291 129.745 452.572 126.444 457.852 127.434C463.132 128.424 472.706 136.676 476.998 137.667C481.29 138.657 482.592 139.549 488.22 139.549C490.697 139.549 500.765 146.909 500.765 146.909C500.765 146.909 506.705 147.898 512.978 150.87C519.25 153.841 525.851 168.035 528.823 172.656C531.794 177.277 532.124 188.501 532.124 188.501C532.124 188.501 540.046 192.791 543.016 198.734C545.987 204.676 655.246 263.43 655.246 263.43C655.246 263.43 672.519 330.989 645.342 391.504Z",
    fill: "url(#paint4_linear_272_15956)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M549.38 305.675C525.249 284.081 505.224 266.192 502.087 263.422C493.492 255.829 487.235 256.162 482.612 251.54C477.99 246.917 475.67 243.63 456.863 243.947C438.039 244.281 412.958 234.051 407.351 230.413C401.743 226.792 393.817 229.429 388.527 227.376C383.253 225.324 369.72 227.126 361.459 227.376C353.216 227.626 352.548 219.199 355.852 209.62C359.156 200.058 384.238 194.118 387.542 196.087C390.846 198.073 404.046 192.465 404.046 192.465C402.061 185.523 402.728 168.686 402.728 168.686C402.728 168.686 388.861 162.745 383.587 160.776C378.297 158.79 371.038 159.457 371.038 159.457C371.038 159.457 372.69 151.881 375.327 149.061C377.963 146.241 390.513 143.604 402.728 135.026C414.943 126.449 422.536 124.463 424.505 125.114C426.491 125.781 440.025 129.736 443.663 129.736C446.416 129.736 450.138 127.834 454.093 127.35C450.889 129.136 448.669 132.54 449.27 134.359C450.221 137.229 452.908 144.538 453.058 145.006C452.341 144.305 435.035 127.217 423.855 128.101C414.193 128.852 404.38 145.122 406.032 157.071C407.684 169.019 403.679 169.019 405.849 177.93C408.001 186.842 409.987 199.391 406.683 204.347C403.379 209.287 396.787 200.492 396.787 200.492C396.787 200.492 388.427 204.681 388.427 214.243C388.427 223.822 398.356 224.472 404.347 225.474C410.321 226.458 432.048 238.407 446.934 239.041C461.819 239.658 461.819 239.658 461.819 239.658C461.819 239.658 453.225 227.96 456.863 227.376C460.484 226.792 471.381 227.843 478.64 239.041C485.916 250.222 491.323 252.741 504.623 258.248C512.299 261.419 533.026 283.797 549.38 305.675Z",
    fill: "url(#paint5_linear_272_15956)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M615.331 241.68C613.311 240.729 548.58 210.223 545.326 205.668C542.022 201.045 538.067 199.994 534.429 195.405C530.807 190.816 518.592 187.845 516.94 181.571C515.288 175.296 513.302 156.255 510.332 153.902C507.361 151.533 502.422 149.063 502.422 149.063L507.328 161.295C507.328 161.295 496.147 145.458 493.494 145.025C490.857 144.607 496.364 156.539 495.88 156.172C495.563 155.938 483.281 144.491 473.135 135.913C474.637 136.781 475.972 137.432 476.99 137.665C481.295 138.65 482.597 139.551 488.22 139.551C490.69 139.551 500.77 146.91 500.77 146.91C500.77 146.91 506.71 147.895 512.985 150.865C519.243 153.836 525.851 168.037 528.822 172.659C531.792 177.282 532.126 188.496 532.126 188.496C532.126 188.496 540.052 192.785 543.023 198.726C544.775 202.247 583.808 224.291 615.331 241.68Z",
    fill: "url(#paint6_linear_272_15956)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M615.378 241.695C615.378 241.695 615.362 241.695 615.328 241.679C615.345 241.679 615.362 241.679 615.362 241.679C615.378 241.695 615.378 241.695 615.378 241.695Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M645.34 391.504C645.34 391.504 510.665 271.022 502.083 263.43C493.5 255.839 487.229 256.168 482.608 251.547C477.987 246.926 475.676 243.626 456.861 243.956C438.045 244.286 412.959 234.053 407.348 230.422C401.736 226.791 393.815 229.433 388.533 227.377C383.251 225.321 369.717 227.121 361.465 227.377C353.213 227.632 352.553 219.2 355.853 209.626C359.154 200.054 384.241 194.111 387.542 196.092C390.842 198.073 404.046 192.461 404.046 192.461C402.065 185.529 402.726 168.694 402.726 168.694C402.726 168.694 388.862 162.754 383.58 160.773C378.298 158.792 371.036 159.453 371.036 159.453C371.036 159.453 372.686 151.883 375.328 149.066C377.968 146.249 390.512 143.609 402.726 135.027C414.939 126.444 422.531 124.464 424.512 125.124C426.492 125.785 440.026 129.745 443.657 129.745C447.289 129.745 452.57 126.444 457.85 127.434C463.13 128.424 472.704 136.676 476.996 137.667C481.288 138.657 482.59 139.549 488.219 139.549C490.695 139.549 500.763 146.909 500.763 146.909C500.763 146.909 506.704 147.898 512.976 150.87C519.248 153.841 525.849 168.035 528.821 172.656C531.792 177.277 532.122 188.501 532.122 188.501C532.122 188.501 540.044 192.791 543.014 198.734C545.985 204.676 655.244 263.43 655.244 263.43",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M402.725 168.697C402.725 168.697 404.265 155.712 402.725 153.898",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M443.438 136.898C443.438 136.898 465.884 155.912 467.643 157.077",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M464.525 130.502C467.606 132.432 492.509 154.503 500.651 159.564",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M532.12 188.501C529.699 187.071 523.317 183.991 522.658 181.569",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M404.047 192.462C404.047 192.462 405.367 197.854 404.047 200.494",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M384.241 209.514C384.241 209.514 381.16 218.096 388.421 223.817",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M414.172 128.098C410.43 131.837 409.77 136.899 409.77 136.899",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M379.84 153.894C379.84 153.894 381.607 159.861 388.422 162.69",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M478.643 247.877C474.024 240.544 464.525 230.203 464.525 230.203",
    stroke: "#003076",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M25 696.75C25 696.75 132.806 625.891 139.408 616.746C146.009 607.599 151.291 603.446 151.291 603.446C151.291 603.446 154.371 577.039 162.293 563.395C170.215 549.752 173.295 539.629 176.816 532.588C180.337 525.546 197.062 520.264 201.903 517.624C206.744 514.984 215.106 509.703 219.947 509.703C224.788 509.703 230.511 512.783 230.511 512.783C230.511 512.783 246.795 504.421 254.277 509.703C254.277 509.703 272.762 510.584 277.163 510.143C281.563 509.703 288.165 512.783 288.165 512.783C288.165 512.783 299.167 504.883 306.65 507.954C314.133 511.023 317.689 512.344 317.891 516.745C318.093 521.146 316.039 536.111 316.039 536.111L312.371 536.109C312.371 536.109 300.047 552.136 298.727 555.345C297.407 558.554 290.364 576.16 290.364 576.16C290.364 576.16 299.608 569.118 305.328 563.836C311.051 558.554 321.173 548.432 331.735 545.792C342.298 543.152 349.779 549.056 349.779 555.345C349.779 555.345 337.455 565.156 334.815 568.237C332.175 571.317 327.406 579.239 322.088 584.961C316.769 590.683 304.447 614.448 293.884 625.891C283.321 637.334 237.109 661.98 226.546 665.501C226.546 665.501 162.288 710.392 134.121 748.242C134.126 748.243 57.5544 748.684 25 696.75Z",
    fill: "url(#paint7_linear_272_15956)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.036 655.82C234.953 656.754 238.708 657.321 243.998 657.422C236.222 661.41 229.747 664.43 226.543 665.498C226.543 665.498 184.523 694.852 153.551 726.108C164.214 709.137 184.69 687.96 192.3 683.554C202.896 677.38 223.255 657.455 223.255 657.455C223.255 657.455 230.982 652.732 234.036 655.82Z",
    fill: "url(#paint8_linear_272_15956)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305.325 563.837C308.813 560.617 313.919 555.61 319.777 551.605C311.366 560.416 306.694 571.764 306.694 571.764C304.658 582.828 285.567 605.64 285.567 605.64C291.725 585.848 286.435 581.877 288.17 576.153C289.889 570.446 291.024 556.395 291.024 556.395C291.024 556.395 294.361 550.637 297.883 549.319C301.404 547.984 310.649 524.671 312.368 521.517C314.103 518.363 300.97 513.224 297.449 512.79C293.928 512.339 292.609 518.497 285.567 521.517C278.525 524.521 269.68 530.078 266.426 533.316C263.289 536.453 257.515 550.871 257.148 551.755C257.398 550.754 261.387 534.684 262.421 531.48C263.289 528.81 271.75 523.887 274.887 522.135C269.68 524.555 266.76 519.965 262.421 515.793C257.765 511.321 250.823 509.903 243.23 512.222C235.637 514.542 230.548 520.266 230.514 519.832C230.481 519.381 219.167 517.412 215.546 518.497C211.924 519.598 203.397 523.42 203.397 523.42C203.397 523.42 195.687 518.981 183.021 531.48C177.731 536.703 160.126 576.603 162.762 571.764C165.332 567.075 176.897 552.74 177.614 551.856C176.797 553.725 153.451 606.157 148.678 609.411C143.838 612.732 142.52 624.564 125.365 634.259C109.045 643.454 46.0986 683.021 39.8574 686.943C69.6617 667.151 134.343 623.78 139.4 616.754C146.008 607.609 151.281 603.454 151.281 603.454C151.281 603.454 154.368 577.037 162.295 563.403C170.222 549.753 173.292 539.623 176.813 532.581C180.334 525.539 197.056 520.266 201.895 517.629C206.751 514.976 215.112 509.702 219.951 509.702C224.79 509.702 230.514 512.79 230.514 512.79C230.514 512.79 246.802 504.412 254.278 509.702C254.278 509.702 272.768 510.587 277.156 510.136C281.562 509.702 288.17 512.79 288.17 512.79C288.17 512.79 299.168 504.88 306.644 507.95C314.136 511.021 317.691 512.339 317.891 516.745C318.091 521.15 316.042 536.107 316.042 536.107L312.368 536.102C312.368 536.102 300.052 552.139 298.734 555.343C297.415 558.547 290.373 576.153 290.373 576.153C290.373 576.153 299.601 569.111 305.325 563.837Z",
    fill: "url(#paint9_linear_272_15956)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M349.783 555.344C349.783 555.344 337.467 565.156 334.814 568.243C333.229 570.096 330.876 573.7 328.072 577.522C330.275 570.58 330.892 563.838 330.892 563.838C330.892 563.838 334.847 557.68 341.456 555.477C344.109 554.593 347.113 554.559 349.75 554.843C349.783 555.01 349.783 555.177 349.783 555.344Z",
    fill: "url(#paint10_linear_272_15956)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M25 696.75C25 696.75 132.806 625.89 139.408 616.746C146.009 607.599 151.291 603.445 151.291 603.445C151.291 603.445 154.371 577.039 162.293 563.395C170.215 549.751 173.295 539.628 176.816 532.588C180.337 525.546 197.062 520.264 201.903 517.624C206.744 514.984 215.106 509.702 219.947 509.702C224.788 509.702 230.511 512.783 230.511 512.783C230.511 512.783 246.795 504.421 254.277 509.702C254.277 509.702 272.762 510.583 277.163 510.143C281.563 509.702 288.165 512.783 288.165 512.783C288.165 512.783 299.167 504.883 306.65 507.953C314.133 511.022 317.689 512.344 317.891 516.745C318.093 521.145 316.039 536.111 316.039 536.111L312.371 536.109C312.371 536.109 300.047 552.136 298.727 555.345C297.407 558.554 290.364 576.159 290.364 576.159C290.364 576.159 299.608 569.117 305.328 563.836C311.051 558.554 321.173 548.431 331.735 545.791C342.298 543.151 349.779 549.055 349.779 555.345C349.779 555.345 337.455 565.156 334.815 568.236C332.175 571.317 327.406 579.238 322.088 584.96C316.769 590.683 304.447 614.448 293.884 625.89C283.321 637.333 237.109 661.979 226.546 665.5C226.546 665.5 162.288 710.392 134.121 748.241",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M290.369 576.156C290.369 576.156 293.009 589.36 287.729 601.243",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M273.203 522.905C273.203 522.905 280.686 519.824 288.167 512.782",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M312.371 536.106C312.371 536.106 314.793 531.265 315.231 526.863",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M254.279 509.7C254.279 509.7 245.696 509.26 239.535 514.762",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M230.512 512.782C230.512 512.782 217.308 518.943 212.688 518.943C208.067 518.943 200.584 525.104 200.584 526.865",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M151.291 603.444C151.291 603.444 157.234 594.641 160.753 584.298",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M276.063 526.863C276.063 526.863 267.701 529.064 264.841 536.106C261.981 543.148 248.777 567.574 248.777 567.574",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M234.032 522.901C232.272 527.082 212.467 563.831 212.467 563.831",
    stroke: "black",
    strokeWidth: 1.66877,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 8C-1 3.02944 3.02944 -1 8 -1H620V1H8C4.13401 1 1 4.13401 1 8H-1ZM620 701H8C3.02944 701 -1 696.971 -1 692H1C1 695.866 4.13401 699 8 699H620V701ZM8 701C3.02944 701 -1 696.971 -1 692V8C-1 3.02944 3.02944 -1 8 -1V1C4.13401 1 1 4.13401 1 8V692C1 695.866 4.13401 699 8 699V701ZM620 0V700V0Z",
    fill: "#E2E3E9",
    mask: "url(#path-1-inside-1_272_15956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_15956",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0051C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_272_15956",
    x1: 344.012,
    y1: 146.345,
    x2: 344.012,
    y2: 286.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_272_15956",
    x1: 412.062,
    y1: 167.552,
    x2: 412.062,
    y2: 275.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_272_15956",
    x1: 344.012,
    y1: 146.345,
    x2: 344.012,
    y2: 286.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_272_15956",
    x1: 507.329,
    y1: 125.007,
    x2: 507.329,
    y2: 391.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_272_15956",
    x1: 451.688,
    y1: 125,
    x2: 451.688,
    y2: 305.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_272_15956",
    x1: 544.233,
    y1: 135.913,
    x2: 544.233,
    y2: 241.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_272_15956",
    x1: 187.39,
    y1: 507.245,
    x2: 187.39,
    y2: 748.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_272_15956",
    x1: 198.774,
    y1: 654.772,
    x2: 198.774,
    y2: 726.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_272_15956",
    x1: 179.817,
    y1: 507.242,
    x2: 179.817,
    y2: 686.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_272_15956",
    x1: 338.928,
    y1: 554.685,
    x2: 338.928,
    y2: 577.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FADFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_15956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00002C0 3.58174 3.58172 0 8 0H620V700H7.99999C3.58171 700 0 696.418 0 692V8.00002Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/LoginImage.6d9d214f7e1625090e58155572f0fd1b.svg";
export { ForwardRef as ReactComponent };